export default __webpack_public_path__ + "static/media/roulette-border.da73f468.svg";